import { useEffect, useState } from 'react';
import { splitTextBySlides } from '../common/utils';
import { isUndefined, last } from 'lodash';
import { CustomObject } from '../types/data';

const default_maxSymbolCountInRow = 50;
const default_maxRowCount = 5;

const textOnly_maxSymbolCountInRow = 35;
const textOnly_maxRowCount = 12;

type TSlide = {
  text: string[];
  image:
    | {
    type: string;
        id: number;
        thumbnail: string;
        original: string;
      }
    | undefined;
  start: number;
  end: number;
};

const generateSlides = (text: string, galleryList: any[], subtitleFragments: any[]) => {
  const { slides: textSlides, paragraphs } = splitTextBySlides(
    text,
    default_maxRowCount,
    default_maxSymbolCountInRow
    // galleryList.length
  );

  // const { slides: textOnlySlides } = splitTextBySlides(
  //   paragraphs.map(v => v.join(' ')).join('\n'),
  //   textOnly_maxRowCount,
  //   textOnly_maxSymbolCountInRow
  // );
  const slides = [];
  // const ln = Math.max(textSlides.length + textOnlySlides.length, galleryList.length);
  const ln = Math.max(textSlides.length, galleryList.length);

  for (let i = 0; i < ln; i++) {
    const start = i * 5;
    const slide: TSlide = {
      text: [],
      image: undefined,
      start,
      end: start + 5,
    };

    // const isTextOnly = !galleryList[i];

    // if (isTextOnly) {
    //   slide.text = textOnlySlides.shift();
    // } else {
    const text = textSlides[i] || last(textSlides);

    slide.text = text;
    slide.image = galleryList[i] || galleryList[galleryList.length - 1];
    // }
    slides.push(slide);
  }


  /// estimate slides duration

  let currentSlide = 0;
  let currentRow = 0;

  const wordSlides: string[][] = [];
  let start = NaN;


  for (const fragment of subtitleFragments) {
    if (isNaN(start)) {
      start = +fragment.begin;
    }

    if (!Array.isArray(wordSlides[currentSlide])) {
      wordSlides[currentSlide] = [];
    }

    let row: string = wordSlides[currentSlide][currentRow];

    if (!row) row = '';

    row += ' ' + fragment.lines[0];

    wordSlides[currentSlide][currentRow] = row.trim();

    if (!slides[currentSlide]) {
      break;
    }

    if (row.trim() === slides[currentSlide].text[currentRow].trim()) currentRow += 1;

    if (currentRow === slides[currentSlide].text.length) {
      slides[currentSlide].start = start;
      slides[currentSlide].end = +fragment.end;
      currentSlide += 1;
      currentRow = 0;
      start = NaN;
    }
  }

  let nextStart, nextEnd;


  for (const slide of slides) {
    const delta = slide.end - slide.start;

    if (!isUndefined(nextStart) && !isUndefined(nextEnd)) {
      slide.start = nextStart;
      slide.end = nextEnd;
    } else if (delta < 5) {
      slide.end += 5 - delta;

      nextStart = slide.start;
      nextEnd = slide.end;
    }
  }

  const out = [];
  let previousEnd = null;
  for(const slide of slides){
    if(previousEnd && previousEnd > slide.start){
      slide.start = previousEnd;
      slide.end = previousEnd+5;
      //slide.text = [];
    }
    previousEnd = slide.end;
    out.push(slide);
  }


  return out;
};

type TData =
  | {
      id: number;
      title: string[];
      description: string;
      images: any[];
      embed_video: any[]
    }
  | CustomObject;

const useStorySlides = (data: TData, subtitles: any[]) => {
  const [state, setState] = useState<TSlide[]>([]);

  useEffect(() => {
    const galleryList: any[] = data.images.map((img: any) => ({
      id: img.vr_preview_url,
      thumbnail: img.vr_preview_url,
      original: img.image_url,
    }));
    if(data.embed_video){
      galleryList.push({
        id: data.embed_video.embed_url,
        thumbnail: data.embed_video.thumbnail_url,
        original: data.embed_video.thumbnail_url,
        type: 'video'
      })
    }

    const slides = generateSlides(data.description, galleryList, subtitles);

    slides.unshift({
      text: [data.title],
      image: undefined,
      start: -5,
      end: 0,
    });

    setState(slides);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.id, subtitles]);

  return state;
};

export default useStorySlides;
